import { AnyAction } from "redux";
import {
  CLEAR_ACTIVE_USER_GROUP_ID,
  SET_ACTIVE_USER_GROUP_ID
} from "../actions/activeUserGroup";

export const activeUserGroup = (state = 0 as number, action: AnyAction) => {
  switch (action.type) {
    case SET_ACTIVE_USER_GROUP_ID:
      return action.id as number;
    case CLEAR_ACTIVE_USER_GROUP_ID:
      return 0;
    default:
      return state;
  }
};

export default activeUserGroup;
